import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import { LocalDatePipe } from "src/app/shared/pipes/local-date.pipe";

@Component({
    selector: "app-export-confirm",
    templateUrl: "./export-confirm.component.html",
})

export class ExportConfirmComponent implements OnInit {

    @Input({ required: true }) display: boolean;
    @Output() onClose = new EventEmitter();

    constructor(public app: AppMainComponent, 
        private localDatePipe: LocalDatePipe,) {}

    ngOnInit(): void {}

    export(type: "open" | "pdf" | "csv" | "xlsx") {
        if (type === "pdf") {
            //this.exportPdf();
        } else if (type === "csv") {
            //this.exportCsv();
        } else if (type === "xlsx") {
            //this.exportXlsx();
        } else if(type === "open") {
            //dthis.showPdf();
        }
    }
    onDialogHide() {
        this.onClose.emit({ close: true });
    }
}